import _regeneratorRuntime from "/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
import * as tslib_1 from "tslib";
import { PACKAGE_VERSION } from "../Version";
import { MiddlewareControl } from "./MiddlewareControl";
import { appendRequestHeader, generateUUID, getRequestHeader, setRequestHeader } from "./MiddlewareUtil";
import { TelemetryHandlerOptions } from "./options/TelemetryHandlerOptions";
/**
 * @class
 * @implements Middleware
 * Class for TelemetryHandler
 */

export var TelemetryHandler =
/*#__PURE__*/
function () {
  function TelemetryHandler() {
    _classCallCheck(this, TelemetryHandler);
  }

  _createClass(TelemetryHandler, [{
    key: "execute",

    /**
     * @public
     * @async
     * To execute the current middleware
     * @param {Context} context - The context object of the request
     * @returns A Promise that resolves to nothing
     */
    value: function execute(context) {
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var clientRequestId, sdkVersionValue, options, featureUsage;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                clientRequestId = getRequestHeader(context.request, context.options, TelemetryHandler.CLIENT_REQUEST_ID_HEADER);

                if (clientRequestId === null) {
                  clientRequestId = generateUUID();
                  setRequestHeader(context.request, context.options, TelemetryHandler.CLIENT_REQUEST_ID_HEADER, clientRequestId);
                }

                sdkVersionValue = "".concat(TelemetryHandler.PRODUCT_NAME, "/").concat(PACKAGE_VERSION);

                if (context.middlewareControl instanceof MiddlewareControl) {
                  options = context.middlewareControl.getMiddlewareOptions(TelemetryHandlerOptions);
                }

                if (typeof options !== "undefined") {
                  featureUsage = options.getFeatureUsage();
                  sdkVersionValue += " (".concat(TelemetryHandler.FEATURE_USAGE_STRING, "=").concat(featureUsage, ")");
                }

                appendRequestHeader(context.request, context.options, TelemetryHandler.SDK_VERSION_HEADER, sdkVersionValue);
                _context.next = 9;
                return this.nextMiddleware.execute(context);

              case 9:
                return _context.abrupt("return", _context.sent);

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                throw _context.t0;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12]]);
      }));
    }
    /**
     * @public
     * To set the next middleware in the chain
     * @param {Middleware} next - The middleware instance
     * @returns Nothing
     */

  }, {
    key: "setNext",
    value: function setNext(next) {
      this.nextMiddleware = next;
    }
  }]);

  return TelemetryHandler;
}();
/**
 * @private
 * @static
 * A member holding the name of the client request id header
 */

TelemetryHandler.CLIENT_REQUEST_ID_HEADER = "client-request-id";
/**
 * @private
 * @static
 * A member holding the name of the sdk version header
 */

TelemetryHandler.SDK_VERSION_HEADER = "SdkVersion";
/**
 * @private
 * @static
 * A member holding the language prefix for the sdk version header value
 */

TelemetryHandler.PRODUCT_NAME = "graph-js";
/**
 * @private
 * @static
 * A member holding the key for the feature usage metrics
 */

TelemetryHandler.FEATURE_USAGE_STRING = "featureUsage";